import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'

@Component({
    selector: 'sf-smartquote-nav',
    imports: [RouterModule],
    templateUrl: './smartquote-nav.component.html',
    styleUrl: './smartquote-nav.component.scss'
})
export class SmartquoteNavComponent {}
